// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url : 'https://enabavka.justraspberry.com/api',
  firebase: {
    apiKey: 'AIzaSyAO-GhtHNBC8SGzr1_BGvovOODAFgKP8Bs',
    authDomain: 'enabavka-9dec1.firebaseapp.com',
    databaseURL: 'https://enabavka-9dec1.firebaseio.com',
    projectId: 'enabavka-9dec1',
    storageBucket: 'enabavka-9dec1.appspot.com',
    messagingSenderId: '470404764833',
    appId: '1:470404764833:web:f926f62d5c08a5df4b8ce0',
    measurementId: 'G-9XHC17JJ9S'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
